/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import Metrics from '@adobe/exc-app/metrics';
import { call, select, put } from 'redux-saga/effects';

import { navigateToSessionView } from '../common/actions';
import { selectInitedStateful } from '../common/sagas';
import { selectSessionRouteParam } from '../common/selectors';
import { createSessionStepIndex, saving } from './data/prefabs';
import { sessionSaveError, sessionSaveSuccess } from '../ui/toast.list';

export default function* saveSessionSaga({ values }) {
  const uuid = yield select(selectSessionRouteParam);
  const action = uuid ? 'updateSession' : 'createSession';
  const stepIndex = yield select(createSessionStepIndex.value);
  const stateful = yield call(selectInitedStateful);

  const nextStepAction = createSessionStepIndex.changeAction(stepIndex + 1);

  try {
    const results = yield call([stateful, action], { uuid, ...values });
    if (!results) {
      throw new Error('No session returned.');
    }
    yield put(sessionSaveSuccess);
    yield put(nextStepAction);
    yield put(saving.unsetAction);

    if (action === 'createSession') {
      yield put(navigateToSessionView({ session: results.uuid }));
      const event = {
        action: 'created',
        element: 'created session',
        feature: 'create session',
        type: 'div',
        widget: {
          name: 'create session',
          type: 'modal'
        }
      };
      const metrics = Metrics.create('dms.gemini');
      metrics.analytics.trackEvent(event);
    }
  } catch (err) {
    yield put(sessionSaveError);
    yield put(saving.unsetAction);
  }
}
